import React, { useState, useEffect } from 'react';
import './App.css';
import AleTours from './AleTours';
import About from './About';
import Privacy from './Privacy';
import Terms from './Terms';
import DeleteAccount from './DeleteAccount';
import Support from './Support';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

const App = () => {
  const [currentPage, setCurrentPage] = useState('home');

  // Handle browser back/forward buttons
  useEffect(() => {
    const handlePopState = (event) => {
      const page = event.state?.page || 'home';
      setCurrentPage(page);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const navigateTo = (page) => {
    setCurrentPage(page);
    // Update browser history
    window.history.pushState({ page }, '', `/${page === 'home' ? '' : page}`);
    // Scroll to top when navigating to a new page
    window.scrollTo(0, 0);
  };

  // Initialize history state on first load
  useEffect(() => {
    const path = window.location.pathname.slice(1) || 'home';
    if (path !== currentPage) {
      setCurrentPage(path);
      window.history.replaceState({ page: path }, '', `/${path === 'home' ? '' : path}`);
    }
  }, []);

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <AleTours />;
      case 'about':
        return <About />;
case 'privacy':
        return <Privacy />;
      case 'terms':
        return <Terms navigateTo={navigateTo} />;
      case 'delete-account':
        return <DeleteAccount navigateTo={navigateTo} />;
      case 'support':
        return <Support />;
      default:
        return <AleTours />;
    }
  };

  return (
    <div className="App">
      <Navigation currentPage={currentPage} navigateTo={navigateTo} />
      <div className="page-content">
        {renderPage()}
      </div>
      <Footer navigateTo={navigateTo} />
    </div>
  );
};

export default App;